$(function () {
  
  $('.product__info-wrapper').on("change", function (event) {
    var variantId = getParam("variant");
    
    if (variantId != null && variantId != $('#illi-notify-restocks-variantId').val()) {
      $('#illi-notify-restocks-variantId').val(variantId);
      var targetVariant = $('#illi-notify-restocks-targetVariant').val();
      if (targetVariant) {
        
        var variants = targetVariant.split(',');
        if (variants.includes(String(variantId))) {
          
          $('.illi-notify-restocks-accept-button').removeClass('is-hidden');
          
          var variantTitle = $('#illi-notify-restocks-variantTitle-' + String(variantId)).val();
          var productTitle = $('#illi-notify-restocks-productTitle').val();
          
          if (variantTitle) {
            $('.illi-notify-restocks-DisplayTitle').text(productTitle + ' - ' + variantTitle);
          } else {
            $('.illi-notify-restocks-DisplayTitle').text(productTitle);
          }
        }
        else {
          
          $('.illi-notify-restocks-accept-button').addClass('is-hidden');
        }
      }
      else {
        
        $('.illi-notify-restocks-accept-button').addClass('is-hidden');
      }
    }
  });

  
  $('.illi-notify-restocks-accept-button').on('click', function () {
    
    $('.illi-notify-restocks-accept-errorMessage').addClass('is-hidden');
    var dialog = document.getElementById("illi-notify-restocks-accept-dialog");
    

    dialog.showModal();
  });
  
  $('.illi-notify-restocks-accept-close-text span').on('click', function () {
    var dialog = document.getElementById("illi-notify-restocks-accept-dialog");
    dialog.close();
  });

  
  $('.illi-notify-restocks-post-button').on('click', function () {
    var email = $('.illi-notify-restocks-accept-email input').val();
    if (email) {
      
      var variantId = $('#illi-notify-restocks-variantId').val();
      var productId = $('#illi-notify-restocks-productId').val();

      

      let targetElements = document.getElementsByClassName("illi-notify-restocks-post-button");
      screenLock(targetElements[0]);
      postAcceptrestocks(email, variantId, productId);
    } else {
      
      $('.illi-notify-restocks-accept-errorMessage span').text("メールアドレスが入力されていません。");
      $('.illi-notify-restocks-accept-errorMessage').removeClass('is-hidden');
    }
  });

  
  $('.illi-notify-restocks-message-close-text span').on('click', function () {
    var dialog = document.getElementById("illi-notify-restocks-message-dialog");
    dialog.close();
  });

  
  $('.illi-notify-restocks-message-close-button').on('click', function () {
    var dialog = document.getElementById("illi-notify-restocks-message-dialog");
    dialog.close();
  });
});


function getParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}


function postAcceptrestocks(email, variantId, productId) {
  $.ajax({
    url: '/apps/notify-restocks/accept',
    type: 'POST',
    dataType: 'json',
    data: {
      mail: email,
      variantId: variantId,
      productId: productId
    },
    timeout: 30000,
  }).then(
    function (res) {
      if (res.status == 'success') {
        
        $('.illi-notify-restocks-message-email').text(email);
        
        var dialog = document.getElementById("illi-notify-restocks-message-dialog");
        dialog.showModal();
        dialog = document.getElementById("illi-notify-restocks-accept-dialog");
        dialog.close();
      } else {
        
        $('.illi-notify-restocks-accept-errorMessage span').text(res.result);
        $('.illi-notify-restocks-accept-errorMessage').removeClass('is-hidden');
      }
      screenUnlock();
    },
    function () {
      
      $('.illi-notify-restocks-accept-errorMessage span').text("no connection.");
      $('.illi-notify-restocks-accept-errorMessage').removeClass('is-hidden');
      screenUnlock();
      return null;
    }
  );
}